export default "__VITE_ASSET__0309f0c7__"